import { Component, OnInit } from '@angular/core';
import {TemplateService} from '../template.service'
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-template',
  templateUrl: './edit-template.component.html',
  styleUrls: ['./edit-template.component.css']
})
export class EditTemplateComponent implements OnInit {

  buttons=[];
  templateType:String = ''
  bodytext:any= '';
  templateData = {
    templatename : '',
    template: {
      type: '',
      image:{
        body:'',
        id:''
      }
    },
    status: '',
    created_at: '',
    status_reason:''
  };
  type = '';
  constructor( private template: TemplateService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void { 
    this.getTemplateById();
  }

  bold(text){
    var bold = /\*(.*?)\*/gm;
    var html = text.replace(bold, '<strong>$1</strong>');            
    return html;
  }

  getTemplateById() {
    const templatename = this.router.url.split('/');
    const merchant_id = JSON.parse(localStorage.getItem('merchantDetails')).merchant_id;
    this.template.getTemplateByName(merchant_id, templatename[templatename.length-1]).subscribe(x => {
      this.templateData = x;
      this.templateData.templatename = templatename[templatename.length-1];
      this.templateType = this.templateData.template.type;
      if(this.templateType != 'video' && this.templateType != 'button') this.bodytext = this.bold(this.templateData.template[this.templateData.template.type].body);
      else if(this.templateType == 'video') this.bodytext = this.bold(this.templateData.template[this.templateData.template.type].title);
      else if(this.templateType == 'button'){
        this.buttons = this.templateData.template[this.templateData.template.type].buttons;
        this.type = this.templateData.template[this.templateData.template.type].body.type;
        this.bodytext = this.bold(this.templateData.template[this.templateData.template.type].body[this.type].body);
      }
    });
  }
}
